import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import { memo } from 'react';

import type { SupporterRow } from '@/api/generated';

import { initials, shownName } from './supporterLabels';

/**
 * The Name cell: the initials circle the wireframe draws, then the name.
 *
 * A hidden person has no name (backend D7), so the avatar shows MUI's neutral
 * glyph rather than letters from "Not available", and the name reads "Not
 * available" as real text (P6, I1). The avatar repeats the name, so a screen
 * reader is spared it.
 *
 * Its own module, memoised, so the render-count test can count one draw per
 * row (NF1, I5).
 */
export const SupporterNameCell = memo(function SupporterNameCell({
  row,
}: {
  row: SupporterRow;
}) {
  const letters = initials(row.name ?? null);
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Avatar
        aria-hidden="true"
        data-testid="supporters-avatar-image"
        sx={{ width: 32, height: 32, fontSize: '0.8125rem' }}
      >
        {letters ?? undefined}
      </Avatar>
      <span>{shownName(row)}</span>
    </Box>
  );
});
